import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Chip,
  styled,
} from '@mui/material';
import { Integration } from '../../types';
import * as Styled from './IntegrationsTable.styles';

// Cтилизация ячеек
const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontWeight: 700,
    padding: '8px 12px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: '6px 12px',
    cursor: 'pointer',
  },
}));

interface IntegrationsTableProps {
  data: Integration[] | null;
  loading: boolean;
  selectedCode: string | null;
  onSelect: (code: string) => void;
}

// Таблица списка интеграций
export const IntegrationsTable: React.FC<IntegrationsTableProps> = ({
  data,
  loading,
  selectedCode,
  onSelect,
}) => {
  const { t } = useTranslation();
  const hasData = (data && data.length > 0) || false;

  return (
    <Styled.TableWrapper>
      {!hasData && loading && <CircularProgress size={32} />}
      {hasData && (
        <TableContainer component={Paper}>
          <Table size="small" aria-label="integrations table">
            <TableHead>
              <TableRow>
                <StyledTableCell width="20%">
                  {t('IntegrationsPage.Table.CODE')}
                </StyledTableCell>
                <StyledTableCell width="30%">
                  {t('IntegrationsPage.Table.FRONT_URL')}
                </StyledTableCell>
                <StyledTableCell width="15%">
                  {t('IntegrationsPage.Table.STATUS')}
                </StyledTableCell>
                <StyledTableCell width="15%">
                  {t('IntegrationsPage.Table.SENDER')}
                </StyledTableCell>
                <StyledTableCell width="20%">
                  {t('IntegrationsPage.Table.NETWORKS')}
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row) => {
                const isSelected = row.code === selectedCode;
                return (
                  <TableRow
                    key={row.code}
                    hover
                    selected={isSelected}
                    onClick={() => onSelect(row.code)}
                  >
                    <StyledTableCell>{row.code}</StyledTableCell>
                    <StyledTableCell>{row.front_url || '-'}</StyledTableCell>
                    <StyledTableCell>
                      <Chip
                        label={
                          row.is_active
                            ? t('IntegrationsPage.Table.ACTIVE')
                            : t('IntegrationsPage.Table.INACTIVE')
                        }
                        color={row.is_active ? 'success' : 'default'}
                        size="small"
                      />
                    </StyledTableCell>
                    <StyledTableCell>{row.sender?.name || '-'}</StyledTableCell>
                    <StyledTableCell>
                      {t('IntegrationsPage.Table.NETWORKS_COUNT', {
                        active: row.networks?.length || 0,
                        inactive: row.inactive_networks?.length || 0,
                      })}
                    </StyledTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {!loading && !hasData && (
        <div>{t('IntegrationsPage.Table.EMPTY') as string}</div>
      )}
    </Styled.TableWrapper>
  );
};

export default IntegrationsTable;
